<template>
  <generic-card
      @click="$emit('click')"
      @delete="$emit('deleteEmployee')"
      :allow-delete="$can('manage', 'all')"
  >

    <template #iconContent>
      <b-avatar
          size="lg"
          variant="light-primary"
          :text="nameInitials"
          class="my-auto"
      />
    </template>

    <template #bodyContent>
      <h4>{{ reactiveDisplay }}</h4>

      <div class="text-truncate">{{ employee.function }}</div>
      <div class="text-truncate">
        <a v-if="employee.email"
           :href="'mailto:'+employee.email">{{ employee.email }}
        </a>
        <span v-else>&nbsp;</span>
      </div>
      <div class="text-truncate">
        <a v-if="employee.phone"
           :href="'tel:'+employee.phone">{{ employee.phone }}
        </a>
        <span v-else>&nbsp;</span>
      </div>
      <div class="text-truncate">
        <a v-if="employee.linkedin"
           target="_blank"
           :href="employee.linkedin">
          <icon icon="linkedin" library="fab" />
        </a>
        <span v-else>&nbsp;</span>
      </div>
    </template>
  </generic-card>

</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import GenericCard from './Card'

export default {
  components: {
    GenericCard
  },
  props: {
    employee: {
      type: Object,
      default: () => {}
    }
  },
  setup (props) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------
    const nameInitials = computed(() => {
      let fullName = JSON.parse(JSON.stringify(props.employee.firstName)) + ' ' + JSON.parse(JSON.stringify(props.employee.name))
      let initials = fullName.split(' ')

      if (initials.length > 1) {
        initials = initials.shift().charAt(0) + initials.pop().charAt(0)
      } else {
        initials = name.substring(0, 2)
      }

      return initials.toUpperCase()
    })

    const reactiveDisplay = computed(() => {
      return props.employee.firstName + ' ' + props.employee.name
    })

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components

      // Data

      // Computed
      nameInitials,
      reactiveDisplay,

      // Methods
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>